import { axiosInstance as axios } from "services";

export const fetchPendingPriceChanges = async (params = {}) => {
  const queryParams = new URLSearchParams();
  Object.keys(params).forEach((key) => {
    if (params[key] !== undefined && params[key] !== null && params[key] !== "") {
      queryParams.append(key, params[key]);
    }
  });
  const queryString = queryParams.toString();
  const url = `/admin/subscription/global-price-change/pending${queryString ? `?${queryString}` : ""}`;
  const { data } = await axios.get(url);
  if (!data.success) throw new Error(data.error?.message || "Failed to fetch pending price changes");
  return data;
};

